import React, { useState } from "react";
import MachinesStatusesIndex from "../features/machinesStatus";

export default function MachinesStatusPage() {
    return <MachinesStatusesIndex />;
}

